import * as actionTypes from './actionTypes';

export const updateSelectedDate = (value) => {
  return {
    type : actionTypes.UPDATE_SELECTED_DATE,
    val:value
  }
}

export const updateExternalUserLogin = (value) => {
  return {
    type : actionTypes.UPDATE_EXTERNAL_USER_LOGIN,
    val:value
  }
}

